import { APPLICATION_ID } from '../../constant/global';
import CookieManager from '../cookies';
import { CookieStorageKeys } from '../cookies/constants';
import {
  ExpireTokenInterface,
  GetTokenInterface,
  SetTokenInterface,
} from './types';

abstract class BaseTokenClient {
  protected static getToken: GetTokenInterface;
  protected static setToken: SetTokenInterface;
  protected static expireToken: ExpireTokenInterface;
}

class AuthTokenManager extends BaseTokenClient {
  private static token: string | null = null;

  protected static getToken: GetTokenInterface = () => {
    if (!AuthTokenManager.token) {
      AuthTokenManager.token = CookieManager.getCookie(
        `${APPLICATION_ID}_${CookieStorageKeys.AUTH_TOKEN}`,
      );
    }
    return AuthTokenManager.token;
  };
  protected static setToken: SetTokenInterface = (token) => {
    AuthTokenManager.token = token;
    CookieManager.setCookie({
      cookieName: `${APPLICATION_ID}_${CookieStorageKeys.AUTH_TOKEN}`,
      value: token,
    });
  };

  public static expireToken: ExpireTokenInterface = () => {
    AuthTokenManager.token = null;
    CookieManager.removeCookie(
      `${APPLICATION_ID}_${CookieStorageKeys.AUTH_TOKEN}`,
    );
  };
}

export default AuthTokenManager;
